module.exports = __webpack_public_path__ + "img/interface OneB Studio_6.aae952d4.jpg";